import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ModalProps, modalStyles } from '@kite_aerolab/shared/components';
import { getBreakpoint, getRandomID, keyDownHandler } from '@kite_aerolab/shared/utils';
import { ModalHeaderComponent } from './modal-header.component';
import { fade, fadeRight, fadeUp } from '../../transitions';
import { ModalContentComponent } from './modal-content.component';

@Component({
  selector: 'kite-modal',
  animations: [fadeRight, fade, fadeUp],
  templateUrl: './modal.component.html',
})
export class ModalComponent implements AfterViewInit {
  @ContentChild(ModalHeaderComponent) header: ModalHeaderComponent;
  @ContentChild(ModalContentComponent) content: ModalContentComponent;

  @Output() onClose = new EventEmitter<boolean>();
  @Input() css: ModalProps['css'];
  @Input() isFull: ModalProps['isFull'];
  @Input() isOpen: ModalProps['isOpen'];
  @Input() type: ModalProps['type'] = 'modal';
  @Input() id: string = getRandomID();
  @ViewChild('modalRef') modalRef: ElementRef<HTMLDivElement>;

  public get modal(): string[] {
    return [
      modalStyles({
        isOpen: this.isOpen,
        isFull: this.isFull,
        type: this.type,
        css: this.css,
      }).className,
    ];
  }

  ngAfterViewInit() {
    this.header.toggle.subscribe((value: boolean) => this.toggleOpen(value));
    this.header.id = this.id;
    this.content.id = this.id;
  }

  handleKeydown(e: any) {
    keyDownHandler(e, this.modalRef.nativeElement);
  }

  toggleOpen(value: boolean) {
    this.onClose.emit(value);
    if (!value) {
      this.isFull = false;
    }
  }

  setFull() {
    this.isFull = true;
  }

  unsetFull() {
    this.isFull = false;
    this.toggleOpen(false);
  }

  isDesktop() {
    const size = getBreakpoint();
    return size === 'xl' || size === 'lg' || size === 'md';
  }
}
